import { AppliedCampaignsFilters } from 'store/models/campaignsFilters';

export const getPreparedAppliedCampaignsFilters = (
    appliedCampaignsFilters: AppliedCampaignsFilters,
    appliedCampaignsFiltersTotalCount: number
): Record<string, string[]> | undefined => {
    return appliedCampaignsFiltersTotalCount > 0
        ? {
              productType: [...appliedCampaignsFilters.productTypes],
              campaignStatus: [...appliedCampaignsFilters.campaignStatuses],
              budgetStatus: [...appliedCampaignsFilters.budgetStatuses],
              moderationStatus: [...appliedCampaignsFilters.moderationStatuses],
              area: [...appliedCampaignsFilters.areas],
              professionalRoles: [...appliedCampaignsFilters.professionalRoles],
              createdByUserIds: [...appliedCampaignsFilters.createdByUserIds],
          }
        : {};
};
